/**
 * Function generates id.
 *
 * see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
 *
 * @return {string} random id
 */
export function generateId() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/helper/id-generator.helper.ts